export const moduleName = "post";
